import { FieldTree } from '@angular/forms/signals'

import { asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'

const EI_SIDOTTU = Symbol('EI_SIDOTTU')

/**
 * Kentän yksisuuntainen sidonta näkymän tietoihin kuten `[ngModel]="arvo"`: kenttä saa sidotun arvon ensimmäisellä kerralla ja
 * aina, kun sidottu arvo muuttuu. Käyttäjän muokkaus säilyy siihen asti, vaikka näkymän muut tiedot päivittyisivät.
 * `naytettava` on kentän arvo, kun sidottu arvo ei sellaisenaan kelpaa kentälle: tekstikenttä ei hyväksy null-arvoa eikä
 * Signal Forms undefined-arvoa, joten oletuksena undefined muutetaan null-arvoksi.
 */
export class Sidonta<T> {
  private _sidottu: unknown = EI_SIDOTTU

  constructor(readonly kentta: FieldTree<T>) {}

  sido(sidottu: unknown, naytettava: T = (sidottu ?? null) as T) {
    if (!Object.is(this._sidottu, sidottu)) {
      this._sidottu = sidottu
      asetaArvo(this.kentta, naytettava, { ilmoita: false })
    }
  }
}

/** Toistuvien rivien sidotut kentät. Avain on sama kuin rivin `track`-lausekkeessa, jotta kenttä elää yhtä kauan kuin rivin elementti. */
export class RivienSidonnat<T> {
  private readonly _sidonnat = new Map<string, Sidonta<T>>()

  constructor(private readonly _luoKentta: () => FieldTree<T>) {}

  sido(avain: string, sidottu: unknown, naytettava: T = (sidottu ?? null) as T) {
    let sidonta = this._sidonnat.get(avain)
    if (!sidonta) {
      sidonta = new Sidonta(this._luoKentta())
      this._sidonnat.set(avain, sidonta)
    }
    sidonta.sido(sidottu, naytettava)
  }

  kentta(avain: string): FieldTree<T> {
    return this._sidonnat.get(avain).kentta
  }
}
